// extracted by mini-css-extract-plugin
export default {"headerContent":"Question_headerContent__qhPN2","layoutForm":"Question_layoutForm__h3zZJ","inputForm":"Question_inputForm__uq9a+"};